import type { Severity } from './types';

export const TEST_ID = 'advisoryCountChips';

// Strongest-to-weakest. Keep this order stable — caller and tests assume it.
export const SEVERITY_ORDER: readonly Severity[] = [
    'prohibited',
    'critical',
    'warning',
    'advisory',
    'info',
    'safe'
] as const;

// Human labels surfaced in aria-label + tooltip. Alphabetical keys per
// Stylelint/sort-keys lineage on prior phases.
export const SEVERITY_NAMES: Record<Severity, string> = {
    advisory: 'advisory',
    critical: 'critical',
    info: 'info',
    prohibited: 'prohibited',
    safe: 'safe',
    warning: 'warning'
};
